import { useMutation } from '@tanstack/react-query';

import { apiRequest } from '../api';
import type { RubricKey } from '../types';

export type ReviewSubmission = {
  reviewer_email: string;
  tse_name: string;
  ticket_number: string;
  ticket_topic: string;
  constructive_feedback: string;
  positive_feedback: string;
} & Partial<Record<RubricKey, string>>;

export type ReviewSubmissionResponse = { score: number };

export function useSubmitReview() {
  return useMutation({
    mutationFn: (input: ReviewSubmission) =>
      apiRequest<ReviewSubmissionResponse>('/api/reviews', { method: 'POST', body: input }),
  });
}
